export const adminLoginTheme = {
  sectionFooterSecondaryContent: { display: "none" },
  hint: { display: "none" }
};
